module.exports = __webpack_public_path__ + "static/American-Care-Miami-Gardens-47b7c0a302172bf6a7ba230db50a94b3.jpg";